"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QrCodeCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const qrcode_react_1 = require("qrcode.react");
const react_1 = require("react");
const tech_1 = require("../../tech");
const useQrCodeImage_1 = require("./useQrCodeImage");
const react_ui_1 = require("@pasport/react-ui");
const QrCodeCard = ({ title, ...qrItem }) => {
    const { value, label } = qrItem;
    const { imageUrl, width, height } = (0, useQrCodeImage_1.useQrCodeImage)(qrItem);
    (0, react_1.useEffect)(() => {
        // const qrCanvas = document.getElementById(`qr-code-card-image`) as HTMLCanvasElement;
        //
        // const margin = 20;
        // const marginBottom = 60;
        // const qrCtx = qrCanvas.getContext("2d") as CanvasRenderingContext2D;
        // const qrImg = qrCtx.getImageData(0,0, qrCanvas.width,qrCanvas.height);
        //
        //
        // const canvas = document.getElementById(`canvas-real`) as HTMLCanvasElement;
        // const width = qrCanvas.width + margin*2;
        // const height = qrCanvas.height + margin + marginBottom;
        // canvas.width = width;
        // canvas.height = height;
        // const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
        // ctx.beginPath();
        // ctx.fillStyle = "white";
        // ctx.fillRect(0,0,width,height)
        // ctx.fill();
        //
        // ctx.putImageData(qrImg,margin,margin)
        // ctx.font = "bold 16px \"Segoe UI\"";
        // ctx.fillStyle = "black";
        // ctx.textAlign = "center";
        // ctx.textBaseline = "middle";
        // ctx.fillText(label ?? "QR kód" , qrCanvas.width/2+margin, qrCanvas.height + margin+ marginBottom/2);
    });
    const downloadQR = () => {
        // const canvas = document.getElementById(`canvas-real`) as HTMLCanvasElement;
        // const pngUrl = canvas
        //     .toDataURL("image/png")
        //     .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = imageUrl;
        downloadLink.download = `${label ? "qr_" + (0, tech_1.normalizeText)(label) : "qrcode"}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    return ((0, jsx_runtime_1.jsx)(react_ui_1.DetailCard, { title: title ?? "QR kód", children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex align-items-center justify-content-center mb-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "p-2 d-none", children: (0, jsx_runtime_1.jsx)(qrcode_react_1.QRCodeCanvas, { id: "qr-code-card-image", value: value }) }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex align-items-center flex-column", children: [(0, jsx_runtime_1.jsx)("div", { className: "shadow border rounded mb-3 border-2 border-dark align-items-center d-flex bg-danger justify-content-center overflow-hidden", children: (0, jsx_runtime_1.jsx)("img", { src: imageUrl, style: { width: 250, maxWidth: '100%' } }) }), (0, jsx_runtime_1.jsx)("div", { className: 'flex-grow-1 justify-content-center d-flex', children: (0, jsx_runtime_1.jsx)(react_ui_1.Button, { color: "dark", onPress: downloadQR, icon: (0, jsx_runtime_1.jsx)(react_ui_1.DownloadIcon, {}), children: " St\u00E1hnout jako obr\u00E1zek" }) })] })] }) }));
};
exports.QrCodeCard = QrCodeCard;
